var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProjectForm',{attrs:{"action":"Update","title":"Update Project","formLoader":_vm.loading,"projectId":_vm.projectId,"form":_vm.data},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }